export const MASCARA_CELULAR = '(00) 00000-0000';
export const MASCARA_TELEFONE = '(00) 0000-0000';
export const MASCARA_TELEFONE_CELULAR = '(00) 0000-00009';
export const MASCARA_CPF = '000.000.000-00';
export const MASCARA_CNPJ = '00.000.000/0000-00';
